import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ResumeContext from "./Resumecontext";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { resumeBuilderSelector } from "./ResumeBuilderActions/selector";
import { openAI } from "../common/OpenAIComponent";
import { appSelector } from "../redux/selector";
import parse from "html-react-parser";

export default function PersonalDetails({ setValue }) {
  const [open, setOpen] = useState(false);
  const {
    selectedJob,
    candidateDetails,
    jobDetails,
    primaryResumeDetails,
    candidateSelectedResume,
  } = useSelector(appSelector);
  const formikRef = useRef();
  const dispatch = useDispatch();
  const contextObject = useContext(ResumeContext);
  //const { selectedJob } = useSelector(appSelector);
  const [relatedTitles, setRelatedTitles] = useState();
  const { resumeFullDetails } = useSelector(resumeBuilderSelector);
  const handleInputChange = (field, e) => {
    if (field === "currentrole") {
      formikRef?.current?.setFieldValue("currentrole", e.target.value);
      contextObject.updateJobTitle(e.target.value);
    } else if (field === "experience") {
      formikRef.current.setFieldValue("experience", e.target.value);
      contextObject.updateExperience(e.target.value);
    }
    //console.log("context", contextObject.experience);
  };
  // const jobDetails = useSelector(
  //   (state) => state.resumeBuilderReducer.jobDetails
  // );

  const handleSubmit = async () => {
    const errors = await formikRef?.current.validateForm();
    if (Object.keys(errors).length > 0) {
      alert("Please fill all required fields correctly");
      return;
    }
    if (contextObject.jobTitle !== " " && contextObject.experience !== "") {
      setValue(1);
    }
  };

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        "currentrole",
        contextObject.jobTitle || ""
      );
      formikRef.current.setFieldValue(
        "experience",
        contextObject.experience || ""
      );
    }
  }, [contextObject.jobTitle, contextObject.experience]);

  // useEffect(() => {
  //   const getTitleSuggestions = () => {
  //     //console.log(contextObject.jobTitle);

  //     const title =
  //       selectedJob.jobtitle &&
  //         selectedJob.jobtitle !== "null" &&
  //         selectedJob.jobtitle !== "undefined"
  //         ? selectedJob.jobtitle
  //         : contextObject.jobTitle;

  //     if (title) {
  //       const msg = `Based on the given job title, suggest a list of **related job titles** that are closely aligned with the same industry, skill set, and responsibilities.
  //           Use **jobDetails.title** if available and valid; otherwise, use **contextObject.jobTitle** as the reference.
  //           The job title is: **${title}**  
  //           Ensure the response follows this JSON format;
  //           {
  //             "related_titles": [
  //               "Related Job Title 1",
  //               "Related Job Title 2",
  //               "Related Job Title 3",
  //               "Related Job Title 4",
  //               ...
  //             ]
  //           }
  //           Provide **at least 10 relevant job titles**. Avoid vague, generic, or unrelated roles. Only include job titles that match the skills and experience level of the given title.`;

  //       openAI(msg, (error, results) => {
  //         if (error) {
  //           console.error("Error fetching titles:", error);
  //         } else {
  //           //console.log("data", results?.related_titles);
  //           setRelatedTitles(results?.related_titles);
  //         }
  //       });
  //     } else {
  //       console.warn("Please Enter Title");
  //     }
  //   };

  //   getTitleSuggestions();
  // }, [contextObject.jobTitle, selectedJob?.jobtitle]);

  const handleChipClick = (title) => {
    contextObject.updateJobTitle(title);
  };

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        padding: 2,
        border: "1px solid #e6e1e1",
        borderRadius: "10px",
        borderTop: "3px solid #406682",
        boxShadow: "0 0 2px grey",
      }}
    >
      <Grid container>
        <Grid xs={6}>
          <Typography
            variant="h6"
            sx={{
              background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              fontWeight: "bold",
            }}
          >
            Personal Details
          </Typography>
          <Typography sx={{ color: "grey", mb: 1 }}>
            Adapt your role to align with the job description!.
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            textAlign: "right",
            alignItems: "center",
          }}
        >
          <Button
            onClick={openDialog}
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              padding: "0px 10px",
              height: "30px",
              borderRadius: "22px 22px 22px 22px",
              color: "#406682",
              textTransform: "none",
              backgroundColor: "white",
              cursor: "pointer",
              border: "1px solid #406682",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "#406682",
                color: "white",
                border: "1px solid #406682",
              },
            }}
          >
            Job Description
          </Button>
        </Grid>
      </Grid>

      <Formik
        innerRef={formikRef}
        initialValues={{
          currentrole: "",
          experience: "",
        }}
        validationSchema={Yup.object().shape({
          // fullname: Yup.string().required("Full Name is required"),
          currentrole: Yup.string().required("Job Title is required"),
          experience: Yup.number()
            .typeError("Experience must be a number")
            .required("Experience is required")
            .positive("Experience must be a positive number")
            .integer("Experience must be an integer"),
          // country: Yup.string().required("Please enter Country "),
          // state: Yup.string().required("Please enter State "),
          // city: Yup.string().required("Please enter City"),
        })}
        onSubmit={(values) => {
          //console.log(values);
          handleSubmit(values);
        }}
        render={({ errors, touched, values, handleSubmit, handleBlur }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1} sx={{ mb: 2 }}>
              <Grid item xs={12} md={6}>
                <label htmlFor="currentrole" style={{ fontSize: "14px" }}>
                  Job Title <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  id="currentrole"
                  name="currentrole"
                  type="text"
                  //disabled
                  autoComplete="off"
                  className={`form-control ${touched.currentrole && errors.currentrole
                    ? "is-invalid"
                    : ""
                    }`}
                  onChange={(e) => handleInputChange("currentrole", e)}
                  onBlur={handleBlur}
                  //value={selectedJob?.jobtitle}
                  value={contextObject.jobTitle}
                />
                {touched.currentrole && errors.currentrole && (
                  <div className="invalid-feedback">{errors.currentrole}</div>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <label htmlFor="experience" style={{ fontSize: "14px" }}>
                  Experience <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="experience"
                  name="experience"
                  type="text"
                  // placeholder="Experience"
                  autoComplete="off"
                  className={` form-control ${touched.experience && errors.experience ? "is-invalid" : ""
                    }`}
                  value={contextObject.experience}
                  onChange={(e) => handleInputChange("experience", e)}
                  onBlur={handleBlur}
                />
                {touched.experience && errors.experience && (
                  <div className="invalid-feedback">{errors.experience}</div>
                )}
              </Grid>

              {/* <Box sx={{ width: "100%", m: 2 }}>
                {selectedJob?.jobtitle && (
                  <div>
                    <label
                      htmlFor="selectedJobTitle"
                      style={{ fontSize: "14px" }}
                    >
                      Selected Job Title
                    </label>
                    <div
                      style={{
                        marginTop: 5,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "5px",
                      }}
                    >
                      <Chip
                        label={selectedJob?.jobtitle}
                        onClick={() => handleChipClick(selectedJob?.jobtitle)}
                        style={{
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "bold",
                          backgroundColor: "aliceblue",
                        }}
                      />
                    </div>
                  </div>
                )}

                {relatedTitles?.length > 0 && (
                  <div>
                    <label htmlFor="relatedTitles" style={{ fontSize: "14px" }}>
                      Related Job Titles
                    </label>
                    <div
                      style={{
                        marginTop: 5,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "5px",
                      }}
                    >
                      {relatedTitles.map((title, index) => (
                        <Chip
                          key={index}
                          label={title}
                          onClick={() => handleChipClick(title)}
                          style={{
                            cursor: "pointer",
                            fontSize: "12px",
                            backgroundColor: "aliceblue",
                            border: "1px solid #ddd",
                            m: 1,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </Box> */}
            </Grid>
            {/* <Button
              variant="contained"
              type="submit"
              style={{
                backgroundColor: "#406882",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              
            </Button> */}
            <Button
              variant="contained"
              type="submit"
              size="small"
              style={{
                backgroundColor: "#406882",
                color: "white",
                textTransform: "capitalize",
                float: "right",
              }}
            //onClick={() => setValue(1)}
            >
              Next
            </Button>
          </form>
        )}
      />
      <Dialog
        open={open}
        onClose={closeDialog}
        fullWidth
        sx={{ "& .MuiDialog-paper": { width: "750px", maxWidth: "90%" } }}
      >
        <DialogContent>
          <Box
            sx={{
              marginBottom: "15px",
              padding: 2,
              border: "1px solid #e6e1e1",
              borderRadius: "10px",
              borderTop: "3px solid #406682",
              boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography variant="h6">
              <span
                style={{
                  background:
                    "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "bold",
                }}
              >
                Job Title:
              </span>
              {` ${selectedJob?.jobtitle}`}
            </Typography>
          </Box>

          <Box
            sx={{
              padding: 2,
              //border: "1px solid #e6e1e1",
              borderRadius: "10px",
              // borderTop: "3px solid #406682",
              // boxShadow: "0 0 2px grey",
              backgroundColor: "white",
              //...paperstyles
            }}
          >
            <Typography
              variant="h6"
              sx={{
                background: "linear-gradient(-90deg, #89bcdf 10%, #406882 90%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                fontWeight: "bold",
              }}
            >
              Job Description
            </Typography>
            <Typography paragraph>
              {selectedJob?.job_description !== null &&
                selectedJob?.job_description !== undefined &&
                selectedJob?.job_description
                ? !selectedJob?.job_description.includes("ahref") &&
                  !selectedJob?.job_description.includes("divclass") &&
                  !selectedJob?.job_description.includes("aclass") &&
                  !selectedJob?.job_description.includes("pclass") &&
                  !selectedJob?.job_description.includes("liclass")
                  ? parse(selectedJob?.job_description)
                  : selectedJob?.job_description.replace(/<[^>]+>/g, "")
                : ""}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
